<template>
  <div class="d-flex">
    <template class="d-inline">
      <Clock
        :display-date="false"
        :display-seconds="true"
        :display-timezone="!timezoneMatch"
        :timezone="localTimezone"
        time="moment"
        class="text-white"
      />
    </template>

    <template v-if="!timezoneMatch">
      <Clock
        :display-date="false"
        class="text-vlight"
        :display-seconds="true"
        :display-timezone="true"
        :timezone="userTimezone"
        time="moment"
      />
    </template>
  </div>
</template>

<script>
import Clock from '@components/clock/clock.vue'

import moment from 'moment-timezone'

export default {
  components: { Clock },
  data() {
    return {
      localTimezone: moment.tz.guess(),
    }
  },
  computed: {
    userTimezone() {
      return this.$store.getters['auth/getTimezone']
    },

    timezoneMatch() {
      return this.userTimezone === this.localTimezone
    },
  },
}
</script>


<style lang="scss">
.userTimezone * {
  color: #a90e03 !important;
}
.timeless-clock-container:nth-child(1) {
    border-right: 1px solid #33414a;
    margin-right: 8px;
    padding-right: 4px;
    margin-left: -1px;
}
</style>
